'use client';

import { UserRound } from 'lucide-react';
import { usePathname } from 'next/navigation';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils/ui-utils';

const AccountTrigger = ({ ...props }: React.ComponentProps<'button'>) => {
  const pathname = usePathname();
  return (
    <Button
      className='tablet-lg:h-auto tablet-lg:text-base tablet-lg:p-0 px-0 text-sm font-normal'
      {...props}
    >
      <UserRound
        strokeWidth={2}
        className={cn('tablet-lg:h-5 tablet-lg:w-5 h-4 w-4', pathname.includes('/faq') && 'text-highlight')}
      />
      <span className='desktop-area-filter:sr-only laptop-lg:not-sr-only'>Konto</span>
    </Button>
  );
};

AccountTrigger.displayName = 'AccountTrigger';

export default AccountTrigger;
